module.exports = __webpack_public_path__ + "img/va.a4e6faaf.svg";